export type Preferences = {
  hideBalance: boolean
  altCurrency: string
}
export const initial = (): Preferences => ({
  hideBalance: false,
  altCurrency: 'USD',
})

export const toggleVisibility = (state: Preferences): Preferences => ({
  ...state,
  hideBalance: !state.hideBalance,
})
